import { useState } from 'react'
import { redirect, useLoaderData, useNavigate } from 'react-router'
import { Flex } from '@radix-ui/themes'
import { InBulkProduct } from '@/components/in-bulk-product'
import { BranchPageHeading } from '@/components/subscription/branch-page-heading'
import { Panel } from '@/components/subscription/panel'
import { TextLink } from '@/components/subscription/text-link'
import { useConfirmationModal } from '@/components/subscription/confirmation-modal'
import { formatDate } from '@/lib/shipment'
import { createClient } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import { FlowerCollectionProduct } from '~/api-client/data-contracts'

export const loader = async () => {
  const subscriptions = await fetchSubscriptions()
  const subscription = subscriptions.data.data[0]

  if (subscription) {
    const placements = await fetchPlacements(subscription.id)
    const product = await fetchProduct(subscription.id)

    return [subscriptions, placements, product] as const
  } else {
    return redirect('/subscription/rose/mypage')
  }
}

function fetchSubscriptions() {
  return createClient(Subscriptions).getSubscriptions({ category: 'rose' })
}

function fetchPlacements(id: string) {
  return createClient(Subscriptions).getSubscriptionsSubscriptionIdPlacements(id)
}

function fetchProduct(id: string) {
  return createClient(Subscriptions).getSubscriptionsSubscriptionIdProduct(id)
}

export const SubscriptionRoseMypageBulk: React.FC = () => {
  const navigate = useNavigate()
  const [subscriptions, placements, product] = useLoaderData<typeof loader>()

  const subscription = subscriptions.data.data[0]
  const nextPlacement = placements?.data?.data?.[0]
  const deliverDate = nextPlacement?.attributes?.ship_at ? formatDate(nextPlacement.attributes.ship_at * 1000, 'M/d（E）') : null
  const products = (product?.data?.included?.filter((item) => item.type === 'flower_collection_product') ?? []) as unknown as FlowerCollectionProduct[]

  const addProduct = async (item: FlowerCollectionProduct) => {
    try {
      await createClient(Subscriptions).postSubscriptionsSubscriptionIdInBulkProducts(subscription.id, { flower_collection_product_id: item.id })
      await navigate(`/subscription/rose/mypage/bulk/done?product_id=${item.id}`)
    } catch (error: any) {
      alert(error.response?.data?.error?.message_displayable ?? 'エラーが発生しました')
    }
  }

  return (
    <>
      <BranchPageHeading main="グッズ一覧" />

      <Panel>
        <div className="flex flex-col gap-1">
          {deliverDate && <p className="text-[14px] font-bold text-black leading-relaxed">{deliverDate}のお届け分のお花に同梱されます</p>}
          <p className="text-[13px] text-[#828282] leading-relaxed">一度に追加できるグッズは1点までです</p>
        </div>
      </Panel>

      <Flex direction="column" align="center" gap="8">
        <div className="grid grid-cols-3 gap-x-3 gap-y-4 max-w-4/5">
          {products.map((item: any) => (
            <InBulkProduct
              key={item.id}
              product={item}
              buttonTitle="追加注文する"
              buttonColor="inverted"
              selected={false}
              onSelect={() => addProduct(item)}
              onUnselect={() => {}}
            />
          ))}

        </div>

        <TextLink to="/subscription/rose/mypage">マイページに戻る</TextLink>
      </Flex>
    </>
  )
}
